import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { reply_id: string };

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useDeleteQuickReplyMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while deleting the quick reply',
    endpoint: ({ reply_id }) => `/api/admin/whatsapp/quick-reply/${reply_id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
